import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7cc3a4bc: FaireBrandEntity = {
  token: "b_7cc3a4bc",
  type: "brand",
  name: "Dame Products",
  avatarUrl:
    "https://cdn.faire.com/fastly/ea84dc83166116847d77501e4b23bb4066e2c97f696d43f3bbd273e121f8f6df.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1d6911c4277e3b61341ea69a2ae131eb1806358234dff8b68b97d28d6e3a4ac4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ea84dc83166116847d77501e4b23bb4066e2c97f696d43f3bbd273e121f8f6df.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1d6911c4277e3b61341ea69a2ae131eb1806358234dff8b68b97d28d6e3a4ac4.jpeg",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 99,
  rating: 4.9,
  reviewCount: 37,
  isTopShop: true,
  isInsider: true,
  description:
    "Dame engineers for sexual wellness by building a welcoming community, designing innovative tools, and bringing life-changing education to your bedroom.\n\nWe began our mission to close the Pleasure Gap — the disparity in satisfaction that people with vulvas experience in the bedroom, versus their cis male counterparts. It’s a real problem! The Dame team represents a wide range of ages, genders, ethnicities, backgrounds, and lifestyles. A variety of voices in the lab helps us develop products that address the needs of as many humans as possible!\n\nFor online training information, web assets, stock updates, and complimentary product testers, please reach out to [redacted-email] or message us on Faire!\n\n*Resale on third-party seller sites like Amazon, Walmart, Etsy, Groupon, eBay, or other auction sites is not permitted.\n\nBrand Assets + Product Images available here: https://drive.google.com/drive/folders/1CT6xw9IiAKtXTPYZ3zqLLQmrGFRydZTM?usp=drive_link\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:47.754Z",
    importedBy: "entity-db-cli",
  },
};
